import { useEffect } from 'react';
import { SCROLL_END_THRESHOLD_PX, TERMS_ACCEPTANCE_LOG_PREFIX } from '@ibk/shared-utils';
export function useTermsIframeScrollEndTracking(isOpen, showIframeFallback, termsDocumentUrl, termsIframeRef, iframeScrollCleanupRef, setHasScrolledTermsToEnd) {
    useEffect(() => {
        if (!isOpen || !showIframeFallback) {
            return undefined;
        }
        const iframe = termsIframeRef.current;
        if (!iframe) {
            return undefined;
        }
        const onIframeLoad = () => {
            iframeScrollCleanupRef.current?.();
            iframeScrollCleanupRef.current = null;
            try {
                const doc = iframe.contentDocument;
                const win = iframe.contentWindow;
                if (!doc || !win) {
                    setHasScrolledTermsToEnd(true);
                    return;
                }
                const checkScroll = () => {
                    const body = doc.body;
                    const root = doc.documentElement;
                    const scrollHeight = Math.max(body?.scrollHeight ?? 0, root.scrollHeight);
                    const clientHeight = win.innerHeight || root.clientHeight;
                    const scrollTop = win.pageYOffset ?? root.scrollTop ?? body?.scrollTop ?? 0;
                    const needsScroll = scrollHeight > clientHeight + SCROLL_END_THRESHOLD_PX;
                    const atEnd = !needsScroll || scrollTop + clientHeight >= scrollHeight - SCROLL_END_THRESHOLD_PX;
                    setHasScrolledTermsToEnd(atEnd);
                };
                win.addEventListener('scroll', checkScroll, true);
                checkScroll();
                iframeScrollCleanupRef.current = () => {
                    win.removeEventListener('scroll', checkScroll, true);
                };
            }
            catch (cause) {
                if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
                    console.debug(`${TERMS_ACCEPTANCE_LOG_PREFIX} Scroll do iframe não rastreável (ex.: cross-origin).`, cause);
                }
                setHasScrolledTermsToEnd(true);
            }
        };
        iframe.addEventListener('load', onIframeLoad);
        if (iframe.contentDocument?.readyState === 'complete') {
            onIframeLoad();
        }
        return () => {
            iframe.removeEventListener('load', onIframeLoad);
            iframeScrollCleanupRef.current?.();
            iframeScrollCleanupRef.current = null;
        };
    }, [isOpen, showIframeFallback, termsDocumentUrl, termsIframeRef, iframeScrollCleanupRef, setHasScrolledTermsToEnd]);
}
